module.exports = __webpack_public_path__ + "img/2.f765812b.svg";